import { BadgeSize, BadgeSkin, BadgeType } from './Badge.types';

export const SKIN = {
  general: 'general',
  standard: 'standard',
  danger: 'danger',
  success: 'success',
  neutral: 'neutral',
  neutralLight: 'neutralLight',
  warning: 'warning',
  warningLight: 'warningLight',
  urgent: 'urgent',
  neutralStandard: 'neutralStandard',
  neutralSuccess: 'neutralSuccess',
  neutralDanger: 'neutralDanger',
  premium: 'premium',
} satisfies { [x in BadgeSkin]: x };

export const TYPE = {
  solid: 'solid',
  outlined: 'outlined',
  transparent: 'transparent',
} satisfies { [x in BadgeType]: x };

export const SIZE = {
  medium: 'medium',
  small: 'small',
  tiny: 'tiny',
} satisfies { [x in BadgeSize]: x };
